<template>
  <div id="headerBar">
    <div class="left-logo">
      <img
        class="logo"
        id="homeLogo"
        :src="require('../assets/img/logo.png')"
      />
    </div>
    <div class="right-menu">
      <div
        :class="
          activedIndex === item.path && activedIndex !== '/home/index'
            ? 'munu-item actived'
            : 'munu-item'
        "
        v-for="(item, index) in menuList"
        :key="item.id"
        @click="onClickItem(item, index)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  watch: {
    "$route.path": {
      handler(toPath) {
        this.activedIndex = toPath;
      },
    },
  },
  data() {
    return {
      activedIndex: null,
      menuList: [
        {
          id: "1",
          title: "首页",
          path: "/home/index",
        },
        {
          id: "2",
          title: "关于集团",
          path: "/home/aboutTeam",
        },
        {
          id: "3",
          title: "集团业务",
          path: "/home/groupBusiness",
        },
        {
          id: "4",
          title: "民生资讯",
          path: "/home/humanNews",
        },
        {
          id: "5",
          title: "产教融合",
          path: "/home/educationCombine",
          disabled: true,
        },
        {
          id: "6",
          title: "服务评估中心",
          path: "/talentDevelop",
          disabled: true,
        },
        {
          id: "7",
          title: "产业生态圈",
          path: "/chanyeshengtai",
          disabled: true,
        },
        {
          id: "8",
          title: "人才发展",
          path: "/home/talentDevelop",
        },
        {
          id: "9",
          title: "联系我们",
          path: "/home/contactUs",
        },
      ],
    };
  },
  methods: {
    onClickItem(item) {
      if (item.title == "首页") {
        this.activedIndex = "#";
      } else {
        this.activedIndex = item.path;
      }
      if (!item.disabled) {
        this.$router.push({
          path: item.path,
        });
      } else {
        Message.closeAll();
        Message({
          duration: 1000,
          message: "正在开发中...",
          type: "warning",
        });
      }
    },
  },
  mounted() {
    this.activedIndex = this.$route.path;
  },
};
</script>

<style lang="scss" scoped>
#headerBar {
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 62px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  .left-logo {
    margin-left: 58px;
    width: 127px;
    height: 33px;
    .logo {
      width: 100%;
      height: 100%;
    }
  }
  .right-menu {
    flex: 1;
    display: flex;
    justify-content: end;
    margin-right: 58px;
    .munu-item {
      cursor: pointer;
      position: relative;
      color: #4a4a4a;
      margin-left: 36px;
      font-weight: 600;
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: 16px;
    }
    .munu-item::after {
      display: block;
      width: 0;
      height: 3px;
      background-color: #e02020;
      content: "";
      position: absolute;
      bottom: -20px;
      left: 50%;
      // width: 100%;
      transition: all 0.5s ease;
    }
    .actived {
      color: #e02020;
    }

    .actived::after {
      display: block;
      width: 0;
      height: 3px;
      background-color: #e02020;
      content: "";
      position: absolute;
      bottom: -20px;
      left: 0;
      // left: 50%;
      width: 100%;
      transition: all 0.8 ease;
    }
    .munu-item:hover::after {
      width: 100%;
      left: 0;
    }
  }
}
#headerBar:hover {
  background-color: #fff;
}
</style>
